import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useUnpinConversation = () => {
  const { unpinConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: IDObject) => conversation.unpin(payload.id),
    onSuccess: (conversation, payload) => {
      unpinConversation(payload.id);
    },
  });

  return mutation;
};
